import React from 'react'
import {
  Text as UIFoundationsText,
  Container as UIFoundationsContainer,
  ThemeUtils,
  Dialog as UIFoundationsDialog,
  DialogMaxWidthSizes,
  IconButtonStyles,
  ContainerPaddings,
  ButtonProps
} from '@dcxwam/dcx-wam-ui-foundations'

interface CartErrorMessageDialogProps {
  errorMessageContent?: {
    message?: string | null
    title?: string
    actions?: Array<ButtonProps> | null
    dismissible?: boolean
  }
  dialogErrorMessageIsOpen: boolean
  setDialogErrorMessageIsOpen: (open: boolean) => void
}

const CartErrorMessageDialog: React.FC<CartErrorMessageDialogProps> = ({
  ...props
}) => {
  const {
    errorMessageContent,
    dialogErrorMessageIsOpen,
    setDialogErrorMessageIsOpen
  } = props

  const errorDialogProps = {
    id: 'error-message-add-to-cart',
    onClose: () => setDialogErrorMessageIsOpen(false),
    zIndex: 1351, // used same as for sag,
    ...(errorMessageContent?.title !== null
      ? { title: errorMessageContent?.title }
      : {}),
    ...(errorMessageContent?.actions && errorMessageContent?.actions !== null
      ? {
          actions: errorMessageContent?.actions,
          dismissible: errorMessageContent?.dismissible
        }
      : { dismissible: true }),
    maxWidth: DialogMaxWidthSizes.SM,
    fullWidth: true,
    dialogContentPadding: false,
    closeButtonStyle: IconButtonStyles.Default
  }

  const configContainerErrorMessage = {
    ...(errorMessageContent?.message === null
      ? {
          padding: ThemeUtils.getResponsiveProp([
            {
              t: ContainerPaddings.Size_5
            }
          ])
        }
      : { padding: ContainerPaddings.Size_5 })
  }
  return (
    <UIFoundationsDialog
      {...{
        isOpen: dialogErrorMessageIsOpen,
        ...errorDialogProps
      }}
    >
      <UIFoundationsContainer {...configContainerErrorMessage}>
        <UIFoundationsText.TextSection>
          <UIFoundationsText content={errorMessageContent?.message || ''} />
        </UIFoundationsText.TextSection>
      </UIFoundationsContainer>
    </UIFoundationsDialog>
  )
}
export default CartErrorMessageDialog
